export const toastTheme = {
  colorScheme: {
    light: {
      root: {
        width: '24rem',
        borderRadius: '8px',
        blur: '6px'
      },
      content: {
        padding: '1rem',
        gap: '0.75rem'
      },
      text: {
        gap: '0.25rem'
      },

      info: {
        background: '#E7ECFF',
        borderColor: '#0061E0',
        color: '#333333',
        detailColor: '#333333'
      },

      success: {
        background: '#E4EEE6',
        borderColor: '#2B7A3A',
        color: '#333333',
        detailColor: '#333333'
      },

      warn: {
        background: '#FEF7D9',
        borderColor: '#F9C642',
        color: '#333333',
        detailColor: '#333333'
      },

      error: {
        background: '#FAE0E1',
        borderColor: '#DD3137',
        color: '#333333',
        detailColor: '#333333'
      }
    }
  }
};
